<template>
  <div class="form-base__footer pt-10">
    <div class="button-box justify-end">
      <v-btn
        depressed
        color="primary"
        class="button-base"
        @click="$emit('btn-click')"
        :loading="loading"
      >
        Подписать и отправить
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefusalFooter',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
